import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import { StdCard } from 'components'
import { bgCompanyReportDetailPath } from 'routes'
import { Cont } from './styled'

const BankGuaranteeRelatedComponent = (props) => {

  const { 
    valueForm,
    // props
  } = props

  const setBGNumber = () =>{
    if(valueForm.referenceBgCompanyDocNumber) return valueForm.referenceBgCompanyDocNumber
    else return 'Link to BG Company'
  }

  return (
    <StdCard title={<span className='stepTitle'>Bank Guarantee Related</span>}>
      <Cont>
        <div>
          Bank Guarantee No.({valueForm.requestType=='new'?'Original':'Extend'}) : 
          <a href={bgCompanyReportDetailPath(valueForm.referenceBgCompanyId)} target="_blank">{setBGNumber()}</a>
        </div>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
  }
}

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeRelatedComponent)
